import { useLocation, useNavigate } from "react-router";
import Hdashboard from "../../../components/Hdashboard";
import React, { useEffect, useState } from "react";
import { classList, learnerDelete } from "../../../api/apiHandler";
import DataTable from "react-data-table-component";
import FontAwesome from "react-fontawesome";
import { TOAST_ERROR, TOAST_SUCCESS } from "../../../utils/common.service";
import JqueryLoad from "../../../JqueryLoad/JqueryLoad";
import { CButton, CFormInput, CInputGroup } from "@coreui/react";
import customStyles from "../../../utils/dataTableStyles";
import useDebounce from "../../../utils/useDebounce";

export default function ClassDetails({ isLoader }) {

    const [classData, setClassData] = useState([])
    console.log('classData: ', classData);
    const navigate = useNavigate()
    const location = useLocation()
    const orgId = location.state && location.state.orgid

    const [search, setSearch] = useState('');
    const debounceSearch = useDebounce(search, 750);

    const GetParentLearnerData = () => {
        isLoader(true)
        classList({ id: orgId, search: search }).then((response) => {
            if (response.code == 1) {
                const dataWithRowCount = response.data.map((row, index) => ({ ...row, count: index + 1 }));
                setClassData(dataWithRowCount);
                isLoader(false)
            } else {
                setClassData([])
                isLoader(false)
            }
        });
    }

    // const handleDelete = (id) => {
    //     learnerDelete({ id: id }).then((response) => {
    //         if (response.code == 1) {
    //             setClassData((prevData) => prevData.filter((user) => user.id !== id))
    //             TOAST_SUCCESS(response.message);
    //         } else {
    //             TOAST_ERROR(response.message);
    //         }
    //     })
    // }

    const handleView = (id, user_id) => {
        navigate('/class_learner', { state: { class_id: id, user_id: user_id } })
    }

    const columns = [
        {
            name: 'No',
            selector: row => row.count,
            sortable: false,
            width: "200px"
        },
        {
            name: 'Class Name',
            selector: row => row.class_name,
            sortable: true,
            width: "200px"
        },
        {
            // name: 'Subject Category',
            name: 'Interested Category',
            selector: row => row.subject_category,
            sortable: true,
            width: "900px"
        },
        {
            name: 'Learner',
            cell: (row) => (
                <button style={{ color: "rgb(87, 8, 97)", border: "none", background: "none" }} onClick={() => handleView(row.id,row.user_id)}>View Learner</button>
            ),
            sortable: true,
            width: "200px"
        }
    ]

    useEffect(() => {
        GetParentLearnerData()
    }, [debounceSearch])

    const handleBack = () => {
        navigate(-1);
    };

    return <>
        <JqueryLoad />
        <Hdashboard />
        <main>
            <div className="dashboard-app d-lg-flex">
                <header className="dashboard-toolbar d-lg-flex justify-content-between">
                    <div className="align-items-center justify-content-between d-flex">
                        <div className="d-flex align-items-center">
                            <a className="menu-toggle align-items-center d-lg-none d-flex">
                                <i className="fa fa-bars" />
                            </a>
                            <a href="index.php" className="d-lg-none d-block brand-logo">
                                <img src="./assets/images/logo.png" alt="logo" />
                            </a>
                        </div>
                    </div>
                </header>

                <span onClick={handleBack} className="mx-4 my-3 mt-4">
                    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.86172 2.225L8.37839 0.75L0.136719 9L8.38672 17.25L9.86172 15.775L3.08672 9L9.86172 2.225Z" fill="#131313" ></path>
                    </svg>
                    <span className="ms-2">Back</span>
                </span>
                <>
                    <div className="fs-3 fw-500 ms-4 mb-2">
                        Class Data
                    </div>
                    <div className="d-flex justify-content-end align-items-center mb-3 search-container">
                        <div className="row me-5">
                            <div className="col">
                                <CInputGroup>
                                    <CFormInput type="text" placeholder="Search" onChange={(e) => setSearch(e.target.value)} />
                                    <CButton style={{ backgroundColor: "rgb(87, 8, 97)", color: "light" }}>
                                        <FontAwesome className="fa-solid fa-search" name="search" />
                                    </CButton>
                                </CInputGroup>
                            </div>
                        </div>
                    </div>
                    <div className="px-5 mt-1">
                        {classData && classData.length > 0 ? (
                            <>
                                <DataTable columns={columns} data={classData} pagination customStyles={customStyles}/>
                            </>
                        ) : (
                            <>
                                <p className="mt-5 text-center text-purple fw-500 fs-3 mt-5">No data Found</p>
                            </>
                        )}
                    </div>
                </>
            </div>
        </main>
    </>
}